import { deleteOrderSetupId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { ORDER_SETUP_LIST } from "../Query/useOrderSetupListQuery";

const mutationResource = Resources.base.orderSetup.mutation;

export const useDeleteOrderSetupMutation = () => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((orderSetupId: number) =>
			deleteOrderSetupId(orderSetupId),
		),
		onError: (error) => {
			console.error(`${t(mutationResource.deleteOrderSetupError)}`, error);
		},
		onSuccess: () => {
			toast.success(`${t(mutationResource.deleteOrderSetupSuccess)}`);
			queryClient.invalidateQueries({ queryKey: [ORDER_SETUP_LIST] });
		},
	});
};
